export const colorTheme = {
    primary: "#4361ee",
    secondary: "#a6a2a2",
    info: "#0d1b2a",
}